import { WFH_REASONS } from '../constants/leaveTypes';

/**
 * Get the display label for a WFH reason value
 * @param {string} wfhReason - The WFH reason value from database
 * @param {string} wfhOtherReason - Optional custom reason when wfhReason is 'others'
 * @returns {string} - Human-readable label
 */
export const getWFHReasonLabel = (wfhReason, wfhOtherReason = '') => {
  if (!wfhReason) return '';
  
  // If "others" is selected, return the custom reason
  if (wfhReason === 'others') {
    return wfhOtherReason || 'Others';
  }
  
  // Find matching label from WFH_REASONS constant
  const reasonOption = WFH_REASONS.find(r => r.value === wfhReason);
  return reasonOption ? reasonOption.label : wfhReason;
};

